import * as $ from "jquery"

/**
 * In some contexts (e.g., documentation), we want to ensure that any link to a
 * different domain opens in a new window/tab.
 */
export default function openRemoteLinksInNewWindow(selector) {
  $(selector).on("click", "a", event => {
    if (
      event.target.host &&
      event.target.host !== location.host &&
      !event.defaultPrevented
    ) {
      event.preventDefault()
      window.open(event.target.href, "_blank")
    }
  })
}
